import { createSelector } from 'reselect';
import { returnJS } from 'utils/helpers';
import { initialState } from './reducer';

const selectPatientRoisDomain = (state) =>
	state.get('patientRois', initialState);

export const makeSelectPatientRois = () =>
	createSelector(selectPatientRoisDomain, (substate) =>
		returnJS(substate.get('rois')),
	);

export const makeSelectPatientRoisLoading = () =>
	createSelector(selectPatientRoisDomain, (substate) =>
		substate.get('loading'),
	);

export const makeSelectPatientRoisRevoking = () =>
	createSelector(selectPatientRoisDomain, (substate) =>
		substate.get('revoking'),
	);
